import React from "react";

import { Row, Col } from "../../Component";
import RichTextDisplayComponent from "../../input/rich-text/RichTextDisplayComponent";
import { LANGUAGES } from "../MultiLanguageInput";
import { parseRichText } from "../../../utilities/formatUtils";
import { richTextToPlainText } from "../../../utilities/vacancyUtils";

// Slate faqat mount paytidagi qiymatni oladi — saqlangandan keyin yangilanishi
// uchun key saqlangan matnga bog'langan.
const SingleLanguageView = ({ value }) =>
  richTextToPlainText(value).length > 0 ? (
    <RichTextDisplayComponent key={value} value={parseRichText(value)} />
  ) : (
    <span className="text-soft">-</span>
  );

// Bitta maydonning uchala tildagi ko'rinishi — tahrirlash rejimidagi kabi
// uch ustunda, shunda ko'rinish bilan forma bir xil o'qiladi.
export const RichMultiLanguageView = ({ value }) => (
  <Row>
    {LANGUAGES.map((language) => (
      <Col md="4" className="mb-2 mb-md-0" key={language.key}>
        <div className="overline-title text-soft mb-1">{language.short}</div>
        <SingleLanguageView value={value?.[language.key]} />
      </Col>
    ))}
  </Row>
);

// Qatorlar ro'yxati (tashqi panelsiz — uni kartaning o'zi beradi).
export const RichListItemsView = ({ items }) =>
  items?.length ? (
    <>
      {items.map((item, index) => (
        <div className="bg-lighter rounded p-3 mb-2" key={index}>
          <span className="badge badge-dim badge-primary mb-2">
            {index + 1}
          </span>
          <RichMultiLanguageView value={item} />
        </div>
      ))}
    </>
  ) : (
    <span className="text-soft">-</span>
  );
